<template>
    <div class="container-fluid d-flex flex-column flex-fill h-100 p-t-30">
        <ak-export
            :bundle="exportBundle"
            :definition="exportDefinition"
            @downloaded="$emit('downloaded')"
        >
            <template v-slot:header="{db, isInitializing}">
                <h2>Export<span v-if="! isInitializing">: {{ db.title }}</span></h2>
            </template>
        </ak-export>
    </div>
</template>

<script>
export default {
    name: 'Export',
    data () {
        return {
            dataFetchParams: {
                page: 1,
                q: '',
                sortby: '',
                direction: ''
            },
        };
    },
    computed: {
        exportBundle () {
            return this.$route.params.exportBundle;
        },
        exportDefinition () {
            return this.$route.params.exportDefinition;
        },
    }
};
</script>
